<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t('Proof of Identity (POI)') }}</h3>
        <span class="fz-16 fw-400">{{ $t('Please fill in your POI information and self portrait photo') }}</span>
      </div>
    </div>
    <b-container fluid class="mt-0 pb-5 mb-5">
      <div id="body-container">
        
        <!-- POI TITLE -->
        <KycTitle :title="kyc_data['poi'].title" :type="'poi'" :status="kyc_data['poi'].status"></KycTitle>
        
        <b-row>
          <b-col cols="12" md="6">
            <!-- DOC TYPE -->
            <DocOption 
              :data="kyc_data['poi'].document" 
              :category="'poi'" 
              :ref="'doc_type'"
              :status="kyc_data['poi'].status"
              @selected-document="selectedDocument($event)">
            </DocOption>
          </b-col>
          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label class="w-100">{{ $t('Identity Card / Passport Number') }} <span class="text-danger">*</span></label>
              <input type="text" v-model="doc_id" name="doc_id" value="" class="form-control" :disabled="kyc_data['poi'].status==0 || kyc_data['poi'].status==1">
              <div v-if="error.doc_id" class="invalid-feedback d-block mb-3">
                  {{error.doc_id}}
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col cols="12" :md="kyc_data['poi'].document[current.poi].list.length==1?'12':'6'" v-for="(item, index) in kyc_data['poi'].document[current.poi].list" :key="index">
            <!-- FILE -->
            <KycFile  
              :data="item" 
              :category="'poi'" 
              :index="index" 
              :isBorwse="true"
              :ref="'file_'+item.type"
              :key="index"
              @capture-file="captureFile($event)" 
              @remove-image="removeImage($event)"
              @toggle-camera="toggleCamera($event)">
            </KycFile>
          </b-col>
        </b-row>

        <KycTitle :title="kyc_data['selfie'].title" :type="'selfie'" :status="kyc_data['selfie'].status"></KycTitle>

        <b-row class="mb-4">
          <b-col cols="12" v-for="(item, index) in kyc_data['selfie'].document[current.selfie].list" :key="index">
            <!-- FILE -->
            <KycFile  
              :data="item" 
              :category="'selfie'" 
              :index="index" 
              :isBorwse="true"
              :ref="'file_'+item.type"
              :key="index"
              @capture-file="captureFile($event)" 
              @remove-image="removeImage($event)"
              @toggle-camera="toggleCamera($event)">
            </KycFile>
          </b-col>
        </b-row>

        <button type="button" v-if="is_visible" class="btn bg-upload-payment d-block w-100 mb-3" @click="submit">{{ $t('Submit') }}</button>
      </div>
    </b-container>
    
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>

  import KycTitle from "@/components/Kyc/KycTitle";
  import Common from '@/services/Common';
  import LoaderComponent from "@/components/LoaderComponent";
  import KycFile from "@/components/Kyc/KycFile";
  import DocOption from "@/components/Kyc/DocOption";
  import FileUploader from '@/components/Kyc/FileUploader.vue';
  import NewPopupInfo from '@/components/NewPopupInfo.vue';

  const kyc_file_type = {
    selfie:
    {
      "title":"Self Portrait Photo",
      "document":[
        {
          "id":1,
          "name":"With Document",
          "list":[
            {'type':4,'label':'With Document','file':'','error':''}
          ]
        }
      ],
    "status":null
    },
    poi:{
      "title":"POI Information",
      "document":[
        {
          "id":1,
          "name":"Identity Card",
          "list":[
            {"type":2,"label":"Photo Front Side",'file':'','error':''},
            {"type":3,"label":"Photo Back Side",'file':'','error':''}
          ]
        },
        {
          "id":2,
          "name":"Passport",
          "list":[
            {'type':5,'label':'Photo','file':'','error':''}
          ]
        }
      ],
      "status":null
    }
  }

  export default {
    name: 'kyc',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isLoading:false,
        doc_id:'',
        is_visible:true,
        current:{
          poi:0,
          selfie:0
        },
        kyc_data:kyc_file_type,
        IdType:'1',
        IdFront:'',
        IdReverse:'',
        IdHold:'',
        data_submit:{},
        error:{
          doc_id:'',
          IdFront:'',
          IdReverse:'',
          IdHold:''
        }
      }
    },
    components: {
      KycTitle,
      KycFile,
      DocOption,
      FileUploader,
      NewPopupInfo,
      LoaderComponent
    },
    methods:{
      captureFile($event) {
        const selected = this.current[$event.category];
        this.kyc_data[$event.category].document[selected].list[$event.index].file = $event.file;
      },
      selectedDocument(data){
        // reset error
        const list = this.kyc_data[data.category].document[this.current[data.category]].list
        for (let i = 0; i < list.length; i++) {
          this.$refs["file_"+list[i].type][0].error = "";
          this.$refs["file_"+list[i].type][0].image = "";
          this.kyc_data[data.category].document[this.current[data.category]].list[i].file="";
        }

        this.current[data.category]=data.index;
      },
      submit(){
        const kycFile = [];
        let is_valid = true;

        Object.keys(this.kyc_data).forEach((key) => {
          const doc_list = this.kyc_data[key].document[this.current[key]].list;
          for (let index = 0; index < doc_list.length; index++) {
            const element = doc_list[index];
            
            if(this.current.poi == 1 && key == 'selfie'){
              element.type = 6;
            }

            const el = this.$refs["file_"+element.type][0];
            if(element.file.indexOf("https")!=-1 && el.status==2){
              is_valid = false;
              this.$refs["file_"+element.type][0].error = "Please Update Your File";
            }
            else if(element.file=="" && el.status!=0 && el.status!=1){
              is_valid = false;
              this.$refs["file_"+element.type][0].error = "File is Required";
            }
            else if(element.file && el.status!=0 && el.status!=1){
              kycFile.push({"type":element.type,"file":element.file});
            }
          }
        });

        if(is_valid){
          this.data_submit = {
            "Member":{
              "doc_id":this.doc_id,
              "doc_type":this.current['poi']+1,
              "poa_type":this.current['poa']+1
            },
            "KycFile":kycFile
          }
          this.isLoading = true;
          Common.newKyc(this.data_submit).then(response => {
            if(response.status == 200 && response.data.success){
              this.isLoading = false;
              const profile = response.data.data;
              this.$swal({
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
              }).then((result) => {
                window.location.reload();
              });
            }
          }).catch(err => {
            this.isLoading = false;
            this.checkError(err);
          });
        }
      },
      checkError(err){
        try{
          const response = err.response;  
          if(response.status == 400){
              Object.keys(response.data.data).forEach((key) => {
                if(key == "Member[doc_id]"){
                  this.error.doc_id = response.data.data[key][0];
                }
                if(key == "Member[doc_type]"){
                  this.$refs['doc_type'].error = response.data.data[key][0];
                }
                if(key == "Member[poa_type]"){
                  this.$refs['poa_type'].error = response.data.data[key][0];
                }
                if(key.indexOf("kycfile")!=-1){
                  const index = parseInt(key.split("-")[1]);
                  const type = this.data_submit["KycFile"][index].type;
                  this.$refs['file_'+type][0].error = response.data.data[key][0];
                }
              });
          }      
          else if(response.status == 401 && response.data.name == "Unauthorized"){
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  this.$router.push({ 
                    path: '/login', 
                  });
                }
          else{
            if(localStorage.getItem("token")){
              var msg = (response.data)?response.data.message:err.message;
              this.$notify({
              type: 'warn',
              text: msg
              })
            }
          }
        }catch(e){
          console.log(err);
        }
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      getKyc(){
        Common.getKyc().then(response => {
          const data = response.data.data;
          if(data.ic){
            this.doc_id = data.ic;
          }
        
        let have_pending = false;
        let have_reject = false;

        Object.keys(this.kyc_data).forEach((key) => {
          
          let is_approve = true;
          let is_pending = false;
          let is_rejected = true;

          const doc_list = this.kyc_data[key].document[this.current[key]].list;
          
          for (let i = 0; i < doc_list.length; i++) {
            if(data.kyc[doc_list[i].type]){
              
              // salah satu ada yang pending
              if(data.kyc[doc_list[i].type].status==0){
                is_pending=true;
                have_pending = true;
              }
              // semuanya harus approve
              if(data.kyc[doc_list[i].type].status!=1){
                is_approve = false;
              }
              // salah satu ada yang reject
              if(data.kyc[doc_list[i].type].status==2){
                is_rejected = false;
                have_reject = true;
              }
              
              if(data.kyc[doc_list[i].type].status!=2){
                this.kyc_data[key].document[this.current[key]].list[i].file = data.kyc[doc_list[i].type].file;
                this.$refs["file_"+doc_list[i].type][0].image = data.kyc[doc_list[i].type].file;
              }

              this.$refs["file_"+doc_list[i].type][0].setStatus(data.kyc[doc_list[i].type].status,data.kyc[doc_list[i].type].rejected_code);
            }
            else{
              is_approve = false;
            }
          }

          this.kyc_data[key].status = is_approve?1:(is_pending?0:(is_rejected?2:null));
        });

        const self = this;
        if(have_pending){
          this.$swal({
            icon: 'info',
            html:"<b class='fz-20 mb-2'>"+self.getMessage('Your KYC has been received!')+"</b><br>"+self.getMessage("Our team will review and verify the documents soon. Thank you for your patience"),
            showConfirmButton: true,
            confirmButtonText: self.getMessage('OK')
          });
        }

        if(!have_reject &&
          (this.kyc_data['poi'].status==0 || this.kyc_data['poi'].status==1)&&
          (this.kyc_data['selfie'].status==0 || this.kyc_data['selfie'].status==1)
        ){
          this.is_visible=false;
        }
        else{
          this.is_visible=true;
        }
          
        }).catch(err => {
          this.checkError(err);
        });
      }
    },
    mounted(){
      Common.profile().then(response => {
        const data = response.data.data;
        if(data.doc_id){
          this.doc_id = data.doc_id; 
        }
        if(data.doc_type){
          this.current['poi'] = parseInt(data.doc_type)-1;
          this.$refs['doc_type'].doc_type = this.current['poi'];

          if(this.current['poi']==1){
            this.kyc_data['selfie'].document[0].list[0].type=6;
          }
        }
        
        this.getKyc();
      }).catch(err => {
        this.checkError(err);
      });
    }
  };
</script>

<style type="text/css">
  .btn-choose-photo{
    max-width: unset !important;
  }
</style>